import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {useGetBrands, useGetDeviceModels, useGetDeviceOverallInfo} from "../services/device";
import UploadDeviceListButton from "./upload-device-list-button";

export default function InsertDeviceForm() {

    const [data, setData] = useState({});
    const [brand, setBrand] = useState("");
    const [model, setModel] = useState("");
    const [allBrands, setAllBrands] = useState([]);
    const [allModels, setAllModels] = useState([]);
    const getDeviceOverallInfo = useGetDeviceOverallInfo();
    const getDeviceModels = useGetDeviceModels();
    const getDeviceBrands = useGetBrands()

    async function getData() {
        const [deviceData, allBrandsData, allModelsData] = await Promise.all([getDeviceOverallInfo(), getDeviceBrands(), getDeviceModels()]);
        setData(deviceData)
        setAllBrands(allBrandsData)
        setAllModels(allModelsData)
    }

    useEffect(() => {
        getData().then()
    }, []);

    const classes = useStyles();

    return (
        <Grid container>
            <Grid item xs={10} md={2}>
                <FormControl variant="filled" size="small" fullWidth className={classes.select}>
                    <InputLabel>نام برند</InputLabel>
                    <Select
                        value={brand}
                        onChange={e => setBrand(e.target.value)}
                    >{allBrands.map(b => <MenuItem value={b}>{b.name}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={10} md={2}>
                <FormControl variant="filled" size="small" fullWidth placeholder="مدل را انتخاب کنید"
                             className={classes.select}>
                    <InputLabel>مدل</InputLabel>
                    <Select
                        value={model.name}
                        onChange={e => setModel(e.target.value)}
                    >{(brand ? allModels.filter(m => m.brand?.tag === brand?.tag) : allModels).map(m => <MenuItem
                        value={m}>{`${m.name} (${m.ram} / ${m.storage})`}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={10} md={8} className={classes.fileBox}>
                <UploadDeviceListButton model={model.tag}/>
            </Grid>

        </Grid>
    )
}


const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
        backgroundColor: 'white'
    }, select: {
        padding: theme.spacing(1)
    },
    fileBox: {
        padding: theme.spacing(1)

    }
}));
